import baseViewTemplate from '../views/base-view.tpl.html'
import moment from "moment";

export class BaseExportsController {

    constructor($scope, $rootScope, $injector) {
        this.scope = $scope;
        this.rootScope = $rootScope;
        this.injector = $injector;

        this.api = this.injector.get('$http');
        this.fileSaver = this.injector.get('FileSaver');
        this.alert = this.injector.get('Alert');
        this.navService = this.injector.get('NavService');
        this.translate = this.injector.get('$translate');
        this.userStore = this.injector.get('Users');
        this.depositService = this.injector.get('Deposit');
        this.currentPageInformation = {};
        this.currentView = 'base';
        this.currentData = {};
        this.exportRunning = false;

        this.baseViewTemplate = baseViewTemplate;

        this.guestlistsStore = this.injector.get('Guestlists').reset({
            persist: false,
            listview: 'LoadGlsForExportsListView'
        });

        this.defaultGuestlistDates = {
            start_date: moment(new Date()).format('YYYY-MM-DD'),
            end_date: moment(new Date()).format('YYYY-MM-DD')
        };

        this._loadDefaultGuestlistDates();

        this._initWatchers();
        this.setSideNavActions();
    }

    downloadFileWithName(path, data, fileName) {
        data = data || {};

        this.api.post(path, data, {responseType: "blob"})
            .then((response) => {
                const blob = new Blob([response.data], {type: response.headers('content-type')});
                this.fileSaver.saveAs(blob, fileName);
                this.exportRunning = false;
            }, (response) => {
                const translatedValue = (path) => {
                    return this.translate.instant(`exports.controllers.error_export_preparation.${path}`);
                };


                this.alert.animatedAlert(
                    translatedValue('title'),
                    translatedValue('content'),
                    'failed',
                    {
                        confirmButtonText: translatedValue('confirm'),
                        showCancelButton: false,
                        confirmButtonColor: '#e01249'
                    }
                );
                this.exportRunning = false;
            });
    }

    getSideNavActions() {
        return [];
    }

    setSideNavActions() {
        this.currentSideNavActions = this.getSideNavActions();
        const customs = _.map(this.currentSideNavActions, (entry) => {
            return {
                label: entry.label,
                action: () => {
                    this.activateView(entry);
                },
                active: (this.currentView === entry.view),
                icon: entry.icon || 'download',
                order: 5
            }
        });

        this.navService.setSideNavCustoms(customs);
        this.scope.$applyAsync();
    }

    updateFieldValue(newValue, field) {
        this.currentData[field] = newValue;
    }

    async activateView(newPage) {
        this.currentData = {};
        this.currentView = '';
        this.currentPageInformation = null;

        if (newPage.activator) {
            newPage.activator();
        }
        this.injector.get('$timeout')(() => {
            this.currentPageInformation = newPage;
            this.currentView = newPage.view;
        }, 200);
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.currentView;
        }, () => {
            this.setSideNavActions();
        })
    }

    startCurrentStateDownload() {
        this.exportRunning = true;
        let fileName = this.currentPageInformation.fileName;
        if(this.currentPageInformation.fileNameFormatter) {
            fileName = this.currentPageInformation.fileNameFormatter(this.currentData)
        }
        this.downloadFileWithName(this.currentPageInformation.path, this.currentData, fileName);
    }

    _loadDefaultGuestlistDates() {
        this.guestlistsStore.commit('setPagination', {perPage: -1});
        this.guestlistsStore.commit('setColumns', [
            {
                key: 'date',
                type: 'datetime',
                visible: true
            }
        ]);

        this.guestlistsStore.dispatch('getData').then(() => {
            let minDate = null,
                maxDate = null;

            _.each(this.guestlistsStore.state.data, (gl) => {
                let curDate = new Date(gl.date);
                if (_.isNull(minDate) || curDate < minDate) {
                    minDate = curDate;
                }
                if (_.isNull(maxDate) || curDate > maxDate) {
                    maxDate = curDate;
                }
            });

            this.defaultGuestlistDates = {
                start_date: moment(minDate).format('YYYY-MM-DD'),
                end_date: moment(maxDate).format('YYYY-MM-DD')
            };

            this.setSideNavActions();
        }, () => {

        });
    }
}

BaseExportsController.$inject = [
    '$scope',
    '$rootScope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/pages/exports/controllers/base-controller.js